import { Button, Fab, Grid, Typography, Checkbox, Icon } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import { makeStyles } from '@material-ui/styles'
import moment from 'moment'
import React, { useCallback, useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'
import { useTranslation } from 'react-i18next'
import { PLATFORM_ID_COOKIE } from '../../../constants/cookies'
import { PDP_DOCUMENTS_LIST, PDP_DOCUMENTS_DOWNLOAD } from '../../../constants/url'
import { usePDPDocumentFileForm } from '../../../containers/FormContainer'
import { DOCUMENT_DELETE_FILE } from '../../../constants/url'
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core'
import { bindParams } from '../../../utils/Link'
import api from '../../../utils/Requester'
import PropTypes from 'prop-types'
import ModalExtraction from './Modals/ModalExtraction'
import fileDownload from 'js-file-download'
import { getFileNameToHeaders, managedFileNotFoundError } from '../../../utils/File'
import Access from '../../../containers/RoleContainer'
import DataTable from '../../../components/NewDataTable/NewDataTable'
import ROLES from '../../../constants/roles'
import { DeleteForever, FontDownload } from '@material-ui/icons'
import { useSnackbar } from 'notistack'
import { downloadFile } from '../../../containers/DataContainer'
import {
	COLUMNS_PDP_DOCUMENTS,
	getIndexOfColumn
} from '../../../utils/Datatable'

const useStyles = makeStyles((theme) => ({
	fab: {
		display: 'block',
		marginLeft: 'auto',
		marginTop: 20,
	},
	addIcon: {
		display: 'flex',
	},
	icon: {
		color: '#134391',
		'&:hover': {
			cursor: 'pointer',
		},
		marginRight: '10px',
	},
	title: {
		display: 'inline-block',
		fontSize: '2em',
		padding: 10,
		color: theme.palette.secondary.main,
		fontWeight: 500,
		marginRight: 20,
	},
	preventionNumber: {
		display: 'inline-block',
		color: theme.palette.secondary.main,
		fontWeight: 400,
		fontSize: '1.2em',
	},
	hrRoot: {
		margin: 0,
		marginBottom: 12,
		marginRight: 'auto',
		marginLeft: 11,
		maxWidth: 100,
		border: '1px solid ' + theme.palette.secondary.main,
	},
	filters: {
		color: theme.palette.secondary.main,
		display: 'inline-block',
		margin: 15,
	},
}))

Documents.propTypes = {
	match: PropTypes.object,
	openCreatePdPContactWithData: PropTypes.func,
	isReadOnly: PropTypes.bool,
	pdpId: PropTypes.string,
	buttonsStyle: PropTypes.object,
	revisionNumber: PropTypes.string,
	pdpNumber: PropTypes.string,
	refreshChevrons: PropTypes.bool,
	setRefreshChevrons: PropTypes.func,
	nextStep: PropTypes.func,
	previousStep: PropTypes.func,
	pdpState: PropTypes.number,
}
function Documents({
	isReadOnly,
	pdpId,
	buttonsStyle,
	revisionNumber,
	pdpNumber,
	refreshChevrons,
	setRefreshChevrons,
	nextStep,
	previousStep,
	pdpState,
}) {
	const classes = useStyles()
	const { t } = useTranslation(['user', 'reports', 'document'])
	const [cookies] = useCookies()
	const [documentPath, setDocumentPath] = useState('')
	const [datatable, setDatatable] = useState({ columns: [], data: [], options: {} })
	const [filterDocuments, setFilterDocuments] = useState([])
	const [refresh, setRefresh] = useState(false)
	const [isOpenExtraction, setIsOpenExtraction] = useState(false)
	const { enqueueSnackbar } = useSnackbar()
	const [isLoading, setIsLoading] = useState(true)
	const [open, setOpen] = React.useState(false)
	const PDPDocumentFileForm = usePDPDocumentFileForm({
		setRefreshChevrons: setRefreshChevrons,
		refreshChevrons: refreshChevrons,
		refresh: refresh,
		setRefresh: setRefresh,
		pdpId: pdpId,
		revisionNumber: revisionNumber,
	})

	const keyTraduction = {
		"DIFFUSION": t('HeadDocument'),
		"CONVOC": t('InvitationToAttend'),
		"OTHER": t('Annex'),
		"NOTIF": t('Endorsement'),
	}

	const openPDPDocumentFileForm = () => {
		PDPDocumentFileForm.open()
	}

	const handleOpen = (documentPath) => {
		setOpen(true)
		setDocumentPath(documentPath)
	}

	const handleClose = () => {
		setOpen(false)
		setDocumentPath('')
	}

	const recoveryPdpDocuments = (res) => {
		const { data, ok } = res

		if (!ok) return enqueueSnackbar(t('view_render_failed'), { variant: 'error' })

		if (data) {
			setDatatable(data)
			setIsLoading(false)
		}
	}

	useEffect(() => {
		api
			.post(bindParams(PDP_DOCUMENTS_LIST, cookies[PLATFORM_ID_COOKIE], pdpId, revisionNumber), {
				nbItemsAsked: 50,
				pageNumber: 1,
			})
			.then(recoveryPdpDocuments)
	}, [refresh])

	const customColumns = [
		{
			name: 'typeDocument',
			component: (value) => keyTraduction[value] || value
		},
		{
			name: 'dateAjout',
			component: (value) => {
				console.log(value)
				if (!value) return ''
				
				// Essayer plusieurs formats pour une meilleure compatibilité
				const formats = ['DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY', 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD']
				let date = moment(value, formats, true) // strict parsing
				
				// Si aucun format ne fonctionne, essayer le parsing automatique
				if (!date.isValid()) {
					date = moment(value)
				}
				
				return date.isValid() ? date.format('DD/MM/YYYY') : ''
			}
		},
		{
			name: 'path',
			component: function componentId(value, tableMeta) {
				let filename = tableMeta.rowData[getIndexOfColumn(datatable.columns, COLUMNS_PDP_DOCUMENTS.NOMFICHIER)]
				let isPdf = filename && filename.toLowerCase().endsWith('.pdf')
				return (
					<div style={{ display: 'flex' }}>
						{isPdf ? (
							<span
								color="#134391"
								className={classes.icon}
								onClick={() => {
									viewDocument(value)
								}}
							>
								<Icon
									style={{
										paddingTop: '1px'
									}}>
									visibility
								</Icon>
							</span>) : (<div style={{ width: 24, height: 24 }} />)
						}
						<span
							color="#134391"
							className={classes.icon}
							onClick={() => {
								downloadDocument(value)
							}}
						>
							<Icon
								style={{
									paddingTop: '1px'
								}}>
								download
							</Icon>
						</span>
						<Access accept={[ROLES.ADMIN, ROLES.PLATFORMMANAGER]}>
							<DeleteForever
								color="secondary"
								className={classes.icon}
								onClick={() => {
									handleOpen(value)
								}}
							></DeleteForever>
						</Access>
					</div>
				)
			},
		}
	]

	const downloadDocument = (path) => {
		downloadFile(path, (res, err) => {
			if (err) {
				managedFileNotFoundError(err, t, enqueueSnackbar)
				console.error(err)
			}
			if (res) fileDownload(res.data, getFileNameToHeaders(res.headers) /* TEMPORARY */)
		})
	}

	const viewDocument = (path) => {
		downloadFile(path, (res, err) => {
			if (err) {
				managedFileNotFoundError(err, t, enqueueSnackbar)
				console.error(err)
			}
			if (res) {
				let fileName = getFileNameToHeaders(res.headers);
				const isPdf = fileName && fileName.toLowerCase().endsWith('.pdf')
				if (isPdf) {
					const blob = new Blob([res.data], { type: 'application/pdf' })
					const url = window.URL.createObjectURL(blob)
					window.open(url, '_blank')
					setTimeout(() => window.URL.revokeObjectURL(url), 10000)
				} else {
					fileDownload(res.data, fileName)
				}
			}
		})
	}


	const deleteDocument = (path) => {
		api
			.delete(bindParams(DOCUMENT_DELETE_FILE, cookies[PLATFORM_ID_COOKIE], pdpId, path))
			.then((res) => {
				const { ok } = res

				if (!ok) {
					enqueueSnackbar(t('errorDeleteDocumentFile'), { variant: 'error' })
					return
				}

				enqueueSnackbar(t('TheFileHasBeenDeleted'), { variant: 'info' })
				setRefresh(!refresh)
				setRefreshChevrons(!refreshChevrons)
				handleClose()
			})
	}

	const AddDocument = () => {
		return (
			<>
				<Fab
					classes={{ root: classes.fab, label: classes.addIcon }}
					color="secondary"
					onClick={openPDPDocumentFileForm}
				>
					<AddIcon className={classes.addIcon} />
				</Fab>
			</>
		)
	}

	const MessageDeleteContact = () => {
		return (
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title"> {t('warning')} !</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						{t('doYouWantToDeleteThisFile')}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="secondary">
						{t('no')}
					</Button>
					<Button
						onClick={() => {
							deleteDocument(documentPath)
						}}
						color="secondary"
						autoFocus
					>
						{t('yes')}
					</Button>
				</DialogActions>
			</Dialog>
		)
	}

	const recoveryLink = (res) => {
		const { data, problem, headers, status } = res
		if (problem)
			return enqueueSnackbar(
				status === 404 ? `${t('reports:noFilePresent')} !` : `${t('reports:somethingWrong')}`,
				{ variant: 'error' },
			)

		if (data) {
			let blob = data
			const _filename = getFileNameToHeaders(headers)
			if (!_filename.includes('.zip'))
				blob = new Blob(['\ufeff', data], {
					type: headers['content-type'],
				})
			fileDownload(blob, _filename)
		}
	}

	const onExtractionSubmit = useCallback(async (values) => {
		// MUST BE LOWERCASE
		const pdpFileTypes = {
			headdocument: 0,
			convocation: 1,
			invitationtoattend: 1,
			annex: 2,
			endorsement: 3,
		}
		const paraName = 'p_FileTypes'
		const params = new URLSearchParams()

		Object.keys(values).forEach((key) => params.append(paraName, pdpFileTypes[key.toLowerCase()]))

		await api
			.get(
				bindParams(PDP_DOCUMENTS_DOWNLOAD, cookies[PLATFORM_ID_COOKIE], pdpId, revisionNumber),
				params,
				{
					headers: {
						Pragma: 'no-cache',
					},
					responseType: 'arraybuffer',
				},
			)
			.then((res) => recoveryLink(res))
			.catch((error) => console.log(error))

		setIsOpenExtraction(false)
	})

	return (
		<>
			<MessageDeleteContact />
			<ModalExtraction
				isOpen={isOpenExtraction}
				onClose={setIsOpenExtraction}
				onSubmit={onExtractionSubmit}
				fileTypes={[...new Set(datatable.data.map((doc) => doc.typeDocument))]}
			/>
			{PDPDocumentFileForm.formular}
			<Typography variant="h3" classes={{ root: classes.title }}>
				{t('Documents')}
			</Typography>
			<Typography classes={{ root: classes.preventionNumber }}>
				{t('preventionPlanNo')} {pdpNumber}
			</Typography>
			<hr className={classes.hrRoot} />
			<Button onClick={() => setIsOpenExtraction(true)} color="secondary" variant="contained" style={{ marginLeft: "16px" }}>
				<Icon>download</Icon>
				{t('extractDocuments')}
			</Button>
			<DataTable
				title={t('Documents')}
				columns={[...datatable.columns]}
				data={datatable.data}
				options={datatable.options}
				customColumns={customColumns}
				isLoading={isLoading}
				customLabels={[
					{
						name: 'typeDocument',
						label: t('document:typeDocument'),
					},
					{
						name: 'dateAjout',
						label: t('document:dateAjout'),
					},
					{
						name: 'nomFichier',
						label: t('document:nomFichier'),
					},
					{
						name: 'commentaire',
						label: t('document:commentaire'),
					},
					{
						name: 'path',
						label: t('document:actions'),
					},
				]}
			/>
			{!isReadOnly && <AddDocument />}
			<div className={buttonsStyle.root}>
				<Grid container direction="row" justify="space-between" alignItems="center">
					<Grid container item xs={4} justify="center">
						<Button className={buttonsStyle.previous} onClick={previousStep}>
							{t('previous')}
						</Button>
					</Grid>
					{pdpState > 1 && (
						<Grid container item xs={4} justify="center">
							<Button className={buttonsStyle.next} onClick={nextStep}>
								{t('next')}
							</Button>
						</Grid>
					)}
				</Grid>
			</div>
		</>
	)
}

export default Documents
